import { RadioButtonGroup } from '@/components/RadioButtonGroup';
import type { StoreLocations } from '@/types';

interface StoreListProps {
  setLocation: (id: string) => void;
  stores: StoreLocations[];
}

export const StoreList = ({ setLocation, stores }: StoreListProps) => (
  <RadioButtonGroup
    fields={stores.map(store => {
      const { city, company, county, id, postalCode } = store;
      const region =
        (county ?? postalCode)
          ? `, ${county ?? ''} ${postalCode ?? ''}`.trim()
          : '';
      const description = `${city ?? ''}${region}`;

      return {
        description,
        label: company ?? '',
        price: 'free',
        value: id ?? '',
      };
    })}
    legend="Click &amp; collect locations"
    onChange={setLocation}
  />
);
